import { HttpBackend, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ITheme } from '../model/theme.model';
import { useThemeColorPalette } from '../utils/theme.util';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private http: HttpClient;
  private readonly THEME_LOCATION = 'assets/theme.json';

  constructor(handler: HttpBackend) {
    this.http = new HttpClient(handler); // make sure interceptors are not used
  }

  public load(): Observable<ITheme> {
    return this.http
      .get<ITheme>(`${this.THEME_LOCATION}?v=${Date.now()}`) // must not be cached
      .pipe(
        tap((theme) => {
          useThemeColorPalette(theme.primary, 'primary');
          useThemeColorPalette(theme.accent, 'accent');
          useThemeColorPalette(theme.warn, 'warn');
        }),
        catchError((error) => {
          if (error instanceof HttpErrorResponse) {
            if (error.status === 404) {
              throw new Error(`Config file int ${this.THEME_LOCATION} not found.`);
            }
          }
          throw error;
        })
      );
  }
}
